const faq = {
	name: 'FAQ | FAQs',
}

export default faq
